import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useFloatRecipients() {
  const api = useAxios();

  const { data } = useQuery({
    queryKey: ["float-recipients"],
    queryFn: () => api.get("/floats/recipients"),
    staleTime: 5 * 60 * 1000,
    throwOnError: false,
  });

  return { recipients: data?.data ?? [] };
}
